import React from 'react';
import Highcharts from 'highcharts';
import * as HC_more from 'highcharts/highcharts-more';
import * as HC_solidgauge from 'highcharts/modules/solid-gauge';
import { options } from './options';

HC_more(Highcharts);
HC_solidgauge(Highcharts);

const chartContainerStyle = {
  height: '100%',
  maxHeight: '100%',
  display: 'flex',
  minWidth: '100%',
  maxWidth: '100%'
};

const chartStyle = {
  height: '100%',
  maxHeight: '100%',
  minWidth: '100%',
  maxWidth: '100%'
};

export class ChartGenerator extends React.Component {

  chart = null;

  generateChart = (isFirstRender) => {
    const { chartId, data, chartConfig, choices, disableAnimation } = this.props;
    const copyChartOptions = Object.assign({}, options);

    Highcharts.setOptions(copyChartOptions);
    const copyChartType = Object.assign({}, chartConfig);
    copyChartType.series = data;
    if (copyChartType.xAxis) {
      copyChartType.xAxis.categories = choices;
    }
    if (!copyChartType.chart) {
      copyChartType.chart = {};
    }
    copyChartType.chart.animation = !disableAnimation;
    if (!copyChartType.plotOptions) {
      copyChartType.plotOptions = {};
    }
    if (!copyChartType.plotOptions.series) {
      copyChartType.plotOptions.series = {};
    }
    copyChartType.plotOptions.series.animation = !disableAnimation;

    // If we don't have a chart object, create a new one
    if (!this.chart || !this.chart.series) {
      this.chart = Highcharts.chart(chartId, copyChartType);
    } else {
      // If we do have a chart object, just go through its existing series object
      // and update its data payloads
      //
      // The data and series objects must be in the same order
      for (let i = 0; i < data.length; ++i) {
        this.chart.series[i].update({
          data: data[i].data
        }, true);
      }

      // Redraw the chart manually afterwards.
      this.chart.redraw();
    }

    if (isFirstRender) {
      this.chart.reflow();
    }

    // Round the corners of the gauge background
    const svg = document.getElementsByTagName('svg');
    if (svg.length > 0) {
      const path = svg[0].getElementsByTagName('path');
      if (path.length > 1) {
        // First path is gauge background
        path[0].setAttributeNS(null, 'stroke-linejoin', 'round');
        // Second path is gauge value
        path[1].setAttributeNS(null, 'stroke-linejoin', 'round');
      }
    }
  };

  componentDidUpdate () {
    const { forceReflowBecauseOfBug } = this.props;
    this.generateChart(forceReflowBecauseOfBug);
  }

  componentDidMount () {
    this.generateChart(true);
  }

  render () {
    const { chartId, data } = this.props;
    return (
      <div style={ chartContainerStyle }>
        <div style={ chartStyle } id={ chartId } />
        { /* We need to use data prop somewhere in render or React won't watch it for changes. */ }
        <div key={ data ? data.length : 0 } />
      </div>
    );
  }
}
